"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PickupPointCard = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _models = require("../../../../models");
var _utils = require("../../../../utils");
var _Address = require("../../../Address");
var _Availability = require("../Availability");
var _Price = require("../Price");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PickupPointCard = ({
  city,
  deliveryMethod,
  deliveryChannelId,
  description,
  estimatedDeliveryDate,
  latitude,
  longitude,
  originalShippingFee,
  outOfStockQuantity,
  shippingFee,
  streetAddress,
  telephoneNumber,
  workingHours,
  zipcode
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    culture,
    timeZone
  } = (0, _culture.useCulture)();
  const deliveryMethodTranslationKey = (0, _utils.getDeliveryMethodTranslationKey)(deliveryMethod);
  const {
    selectedPickupPoint,
    setSelectedDelivery
  } = (0, _contexts.useMap)();
  const {
    addressFormat
  } = (0, _contexts.useCheckoutDeliveryContext)();
  const onPickupPointSelection = (0, _react.useCallback)(() => {
    setSelectedDelivery(deliveryChannelId, latitude !== undefined && longitude !== undefined ? {
      latitude,
      longitude
    } : undefined);
  }, [deliveryChannelId, latitude, longitude, setSelectedDelivery]);
  const isSelected = selectedPickupPoint?.deliveryChannelId === deliveryChannelId;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_models.TestId.PickupPointCard),
    "data-id": deliveryChannelId,
    onClick: onPickupPointSelection,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Radio, {
        checked: isSelected
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.RightPanel, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Section, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DeliveryMethod, {
          variant: "tag",
          size: "small",
          label: translations[deliveryMethodTranslationKey]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DescriptionAndPrice, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Description, {
            children: description
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Price.Price, {
            originalShippingFee: originalShippingFee,
            shippingFee: shippingFee
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Address.Address, {
          city: city,
          streetAddress: streetAddress,
          zipcode: zipcode,
          addressFormat: addressFormat
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DateAndAvailability, {
          children: [estimatedDeliveryDate ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            children: (0, _culture.formatDate)(estimatedDeliveryDate, _culture.DateFormat.MonthDay, culture, timeZone)
          }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Availability.Availability, {
            quantity: outOfStockQuantity
          })]
        })
      }), isSelected ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Section, {
        children: [workingHours ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.InfoLine, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clock, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.InfoLineText, {
            children: workingHours
          })]
        }) : null, telephoneNumber ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.InfoLine, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Telephone, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.InfoLineText, {
            children: telephoneNumber
          })]
        }) : null]
      }) : null]
    })]
  });
};
exports.PickupPointCard = PickupPointCard;